import type { ButtonProps } from '@cxnpl/ui';
import { Button, IconButton, Image, Stack } from '@cxnpl/ui';
import { X } from '@cxnpl/ui/icons';
import branding from '@cxnpl/ui/brand';
import { ResponsiveWidthStack } from '../ResponsiveWidthStack';
import type { ConfirmationSuccessDetailsProps } from './ConfirmationSuccessDetails';
import { ConfirmationSuccessDetails } from './ConfirmationSuccessDetails';

export interface ConfirmationSuccessProps {
  /** Title */
  title: ConfirmationSuccessDetailsProps['title'];
  /** Subheading */
  body?: ConfirmationSuccessDetailsProps['body'];
  /** Features title */
  featuresTitle?: ConfirmationSuccessDetailsProps['featuresTitle'];
  /** Features  */
  features?: ConfirmationSuccessDetailsProps['features'];
  /** onClose callback */
  onClose?: () => void;
  /** onSubmit callback */
  onSubmit: () => void;
  /** Submit button label */
  submitButtonLabel: string;
  /** Submit button props */
  submitButtonProps?: Partial<ButtonProps>;
}

export const ConfirmationSuccess = ({
  title,
  body,
  featuresTitle,
  features,
  onSubmit,
  onClose,
  submitButtonLabel: buttonText,
  submitButtonProps,
}: ConfirmationSuccessProps) => {
  return (
    <Stack
      backgroundColor="$background/surface"
      minHeight="100dvh"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      {/* Logo */}
      <Stack position="absolute" top="$space.xl" left="$space.2xl" zIndex={1}>
        <Image
          src={branding.assets.logo.src}
          width={branding.assets.logo.width}
          height={branding.assets.logo.height}
          alt=""
          nativeProps={{ resizeMode: 'contain' }}
        />
      </Stack>
      {/* Close Button */}
      {onClose ? (
        <IconButton
          testID="close-button"
          position="absolute"
          top="$space.xl"
          right="$space.2xl"
          zIndex={1}
          icon={<X />}
          onPress={onClose}
          mode="secondary"
          variant="outlined"
          size="lg"
        />
      ) : null}
      <ResponsiveWidthStack
        alignItems="flex-start"
        justifyContent="center"
        gap="$4xl"
        paddingVertical="$space.8xl"
        paddingHorizontal="$space.2xl"
      >
        <ConfirmationSuccessDetails title={title} body={body} featuresTitle={featuresTitle} features={features} />
        {/* Continue Button */}
        <Stack width="100%" $laptop={{ display: 'unset' }}>
          <Button onPress={onSubmit} {...submitButtonProps}>
            {buttonText}
          </Button>
        </Stack>
      </ResponsiveWidthStack>
    </Stack>
  );
};
